import * as yup from 'yup'

import emailBlacklist from '~helpers/email-blacklist.json'

// Determines if email is coming from blacklisted providers and invalidates submission if so
// eslint-disable-next-line func-names
yup.addMethod(yup.string, 'corporateEmail', function (message) {
  return this.test({
    name: 'corporateEmail',
    exclusive: true,
    message:
      message ||
      'Sign ups from this domain are not allowed. Please try a different company email.',
    test(value) {
      const domain = value?.substring(value.lastIndexOf('@') + 1)

      if (emailBlacklist.includes(domain)) {
        return false
      }

      return true
    },
  })
})
